import { ref, shallowRef } from "@vue/reactivity";
import Record from "@/lib/recorder/record-sdk";
import axios from "axios";
import SessionUtil from "@/utils/SessionUtil";
import GeocoderUtil from "@/utils/GeocoderUtil";
import RouterUtil from "@/utils/RouterUtil";
import { showConfirmDialog } from "vant";
export default {
  name: "VoiceForm",
  props: {
    startAddress: {
      type: String,
      require: true,
      default: "正在获取上车点位置..."
    },
    startPosition: {
      type: Array,
      require: true,
      default: []
    },
    adcode: {
      type: String,
      require: true,
      default: ""
    },
    enterCallback: {
      type: Function,
      require: true,
      default: null
    },
    errorCallback: {
      type: Function,
      require: true,
      default: null
    }
  },
  setup() {
    const recorder = new Record();
    const isRecorder = ref(false);
    const isRecorderEnd = ref(false);
    const isPlaying = ref(false);
    const audio = shallowRef();
    const audioFile = shallowRef();
    const loading = ref(false);
    return {
      recorder,
      isRecorder,
      isRecorderEnd,
      isPlaying,
      audio,
      audioFile,
      loading
    };
  },
  methods: {
    startVoice() {
      if (this.loading) {
        return;
      }
      if (this.isRecorderEnd) {
        if (!this.isPlaying) {
          this.playAudio();
        } else {
          this.stopAudio();
        }
        return;
      }
      if (!this.isRecorder) {
        this.stopAudio();
        this.recorder.startRecord({
          success: res => {
            console.log(res);
          },
          error: e => {
            console.log(e);
          }
        });
        this.isRecorderEnd = false;
        this.isRecorder = true;
      } else {
        this.stopVoice();
      }
    },
    stopVoice() {
      this.recorder.stopRecord({
        success: res => {
          //此处可以获取音频源文件(res)，用于上传等操作
          console.log('音频源文件', res);
          this.audioFile = res;
          this.isRecorderEnd = true;
          this.isRecorder = false;
        },
        error: e => {}
      });
    },
    // 播放录音
    playAudio() {
      console.log('音频源文件', this.audioFile);
      this.audio = document.getElementById("audio");
      this.recorder.play(this.audio, this.audioFile);
    },
    stopAudio() {
      if (this.audio) {
        this.recorder.clear(this.audio);
        this.isPlaying = false;
      }
    },
    againButtonClick() {
      const that = this;
      showConfirmDialog({
        message: "确定要重新开始说话吗？"
      }).then(function () {
        that.stopAudio();
        that.isPlaying = false;
        that.isRecorderEnd = false;
        that.isRecorder = false;
      }).catch(function () {});
    },
    enterButtonClick() {
      if (!SessionUtil.isLogin()) {
        RouterUtil.go("/login", false, this.$route.path);
        return;
      }
      const that = this;
      that.loading = true;
      const startPosition_BD09 = GeocoderUtil.GCJ02_BD09(that.startPosition[0], that.startPosition[1]);
      axios.post("https://wx.dadi.korange.cn/wx_upload_voice", {
        voice: that.audioFile,
        openid: "tims-" + SessionUtil.getUserData("id"),
        mobile: SessionUtil.getUserData("phone_number"),
        address: that.startAddress,
        lng: startPosition_BD09[0],
        lat: startPosition_BD09[1],
        adcode: that.adcode
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        const data = response.data;
        if (data) {
          const rs = data.split(",");
          if (parseInt(rs[0]) === 200) {
            that.stopAudio();
            that.isPlaying = false;
            that.isRecorderEnd = false;
            that.isRecorder = false;
            if (that.enterCallback) {
              that.enterCallback(true, rs[1]);
            }
          } else {
            if (that.enterCallback) {
              that.enterCallback(false, rs[1]);
            }
          }
        }
      }).catch(function (error) {
        if (that.errorCallback) {
          that.errorCallback(error);
        }
      }).finally(function () {
        that.loading = false;
      });
    }
  }
};